export const USER_PREFERENCES_ERRORS = {
  INVALID_TF_CODE: 'invalid-multi-factor-code',
  MISSING_TF_CODE: 'missing-multi-factor-code',
  MISSING_FIRST_NAME: 'missing-first-name-error',
  MISSING_LAST_NAME: 'missing-last-name-error',
  TOGGLE_MODAL_ERROR: 'toggle-user-pref-modal-error',
  UNKNOWN_ERROR: 'unknown-user-pref-error',
  UPDATE_PROFILE_ERROR: 'update-user-profile-error',
};

export const EDIT_DETAILS_FORM_TEXT = {
  PROFILE_PHOTO: {
    UPLOAD_BUTTON: 'Upload new photo',
    REMOVE_BUTTON: 'Remove photo and use initials instead',
    ID: 'profile-photo',
    LABEL: 'Profile photo',
  },
  FIRST_NAME: {
    ID: 'first-name',
    LABEL: 'First name',
    ERROR: 'Enter a first name',
  },
  LAST_NAME: {
    ID: 'last-name',
    LABEL: 'Last name',
    ERROR: 'Enter a last name',
  },
  SAVE_BUTTON_ID: 'save-details-button',
  SAVE_BUTTON: 'Save changes',
  CANCEL_BUTTON: 'Cancel',
};

const MAX_IMAGE_SIZE_IN_MB = 3;
export const MAX_IMAGE_SIZE = MAX_IMAGE_SIZE_IN_MB * 1000 * 1024;
export const MIN_IMAGE_SIZE = 0;
export const ACCEPTS_TYPES = {
  'image/png': ['.png'],
  'image/jpeg': ['.jpg', '.jpeg'],
  'image/gif': ['.gif'],
};

export const USER_PREFERENCES_PAGE_TEXT = {
  PROFILE: {
    DESCRIPTION: 'Configure your name, profile photo and password.',
    TITLE: 'Profile',
  },
  SECURITY: {
    AUTH_METHOD: 'Authentication method',
    DESCRIPTION: 'Enable additional security measures like two factor authentication',
    DISABLE_TWO_FACTOR_AUTH_BUTTON: 'Disable multi-factor authentication',
    RESET_PASSWORD_BUTTON: 'Reset password',
    TITLE: 'Security',
    TWO_FACTOR_AUTH: 'Multi-factor authentication',
    ENABLE_TWO_FACTOR_AUTH_BUTTON: 'Enable multi-factor authentication',
  },
  EDIT_BUTTON: 'Edit details',
};
